import { SIGNUP_REGIONS, type SignupRegion } from '@server/signup-answers';
import { useId } from 'react';

import { RadioGroup, RadioGroupItem } from '@/_shared/components/ui/radio-group';

import { REGION_LABELS } from '../../lib/signup-regions';
import { RegionFlag } from '../regionFlag/RegionFlag';

/** The region choice of both sign-up paths: the form behind the emailed link, and Google. */
export function RegionRadioGroup({
  value,
  onValueChange,
  selectedRef,
  ...props
}: Omit<React.ComponentProps<typeof RadioGroup>, 'value' | 'onValueChange' | 'children'> & {
  value: SignupRegion;
  onValueChange: (region: SignupRegion) => void;
  selectedRef?: React.Ref<HTMLButtonElement>;
}): React.ReactElement {
  const idPrefix = useId();
  return (
    <RadioGroup
      {...props}
      value={value}
      onValueChange={(next) => onValueChange(next as SignupRegion)}
      className="grid gap-2"
    >
      {SIGNUP_REGIONS.map((region) => (
        <RadioGroupItem
          key={region}
          value={region}
          id={`${idPrefix}-${region}`}
          ref={region === value ? selectedRef : undefined}
        >
          <span className="flex items-center gap-2">
            <RegionFlag region={region} className="size-4" />
            {REGION_LABELS[region]}
          </span>
        </RadioGroupItem>
      ))}
    </RadioGroup>
  );
}
